<template>
  <div class="faq-component">
    <div class="faq-header">
      <h1>Questions? Look here</h1>
      <h5>Can't find an answer? Chat us</h5>
    </div>
    <div class="faq-content">
      <el-collapse accordion v-model="activeName" @change="handleChange">
        <el-collapse-item name="0">
          <template slot="title">
            <div class="faq-content-title-wrapper">
              <div class="faq-icon-wrapper">
                <plus-icon v-if="!collapses[0]" class="faq-icon"></plus-icon>
                <minus-icon v-else class="faq-icon"></minus-icon>
              </div>
              <h2>Consistency</h2>
            </div>
          </template>
          <div class="faq-description">
            <p>Consistent with real life: in line with the process and logic of real life, and comply with languages and habits that the users are used to;</p>
          </div>
        </el-collapse-item>
        <el-collapse-item name="1">
          <template slot="title">
            <div class="faq-content-title-wrapper">
              <div class="faq-icon-wrapper">
                <plus-icon v-if="!collapses[1]" class="faq-icon"></plus-icon>
                <minus-icon v-else class="faq-icon"></minus-icon>
              </div>
              <h2>Feedback</h2>
            </div>
          </template>
          <div class="faq-description">
            <p>Operation feedback: enable the users to clearly perceive their operations by style updates and interactive effects</p>
          </div>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title">
            <div class="faq-content-title-wrapper">
              <div class="faq-icon-wrapper">
                <plus-icon v-if="!collapses[2]" class="faq-icon"></plus-icon>
                <minus-icon v-else class="faq-icon"></minus-icon>
              </div>
              <h2>Efficiency</h2>
            </div>
          </template>
          <div class="faq-description">
            <p>Simplify the process: keep operating process simple and intuitive</p>
          </div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import { PlusIcon, MinusIcon } from 'vue-feather-icons';

export default {
  data() {
    return {
      activeName: null,
      lastCollapseIndex: null,
      collapses: [ // this will track collapse icon plus/minus
        false,
        false,
        false,
      ],
    };
  },
  components: {
    PlusIcon,
    MinusIcon,
  },
  methods: {
    handleChange(val) {
      if (val !== '') {
        // the user open the new one
        // set the last collapse to plus icon
        this.collapses[this.lastCollapseIndex] = false;
        // set the currenct collapse as last collapse
        this.lastCollapseIndex = val;
        // set the currenct collapse to minus icon
        this.collapses[val] = true;
      } else {
        // the user close the current one
        // set the last collapse to t plus icon
        this.collapses[this.lastCollapseIndex] = false;
        // no last collapse
        this.lastCollapseIndex = null;
      }
    },
  },
  created() {
    this.activeName = this.$route.query.index;
    this.lastCollapseIndex = this.$route.query.index;
  },
  mounted() {
  },
  watch: {
  },
};
</script>

<style>
.faq-component {
  width: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.faq-content {
  max-width: 1024px;
  width: 95%;
  text-align: left;
  margin: 0 auto;
}

.faq-content-title-wrapper{
  display: flex;
  flex-direction: row;
}

.faq-content-title-wrapper h2 {
  margin: auto 0px;
}

.faq-icon-wrapper {
  display: flex;
  align-items: center;
  margin-right: 24px;
}

.faq-description {
  margin-left: 48px;
  display: flex;
  flex-direction: column;
  text-align: justify;  
}

.faq-description p {
  font-size: 1.3em;
}

.faq-icon {
  color: #409EFF;
}

/* remove the right arrow */
.el-collapse-item div div i {
  display: none !important;
}

@media only screen and (max-width: 426px){
  .faq-icon-wrapper {
    margin-right: 12px;
  }

  .faq-content-wrapper {
    margin: 0px 36px;
  }

}
</style>




// WEBPACK FOOTER //
// Faq.vue?23b4b2bc